import FieldDimensionId from '@core/constants/FieldDimension';
import { ExtensionShapeId } from '@core/constants/Shape';
import {
    IDimensionUnit, IFormFieldShapeDimension, IFormInputType,
} from '../../../interfaces/Form';

export const fieldExtension:IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            ExtensionShapeId.CentralExtension,
            ExtensionShapeId.OffsetExtension,
        ],
        required: false,
    },
    dimension: {
        options: {
            [ExtensionShapeId.CentralExtension]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 700 },
                    required     : false,
                    defaultValue : 500,
                },
            },
            [ExtensionShapeId.OffsetExtension]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 700 },
                    required     : false,
                    defaultValue : 500,
                },
            },
        },
    },
};

export default fieldExtension;
